import Label from "components/general/Label";
import React, { useMemo, useState, useEffect } from "react";
import { useViewport } from 'components/general/useViewPort';
import MirsTable from "components/general/table/Table";
import { resultsColumns } from "../events/common/columns";
import { isLiveStatus, isStartListStatus, isFinishedStatus } from "helpers/status";
import LoaderSubComponent from "components/general/LoaderSubComponent";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import NotAvailable from "components/common/NotAvailable";
import { TableExpandedIndividual,TableExpandedGroups } from "../events/common/TableExpandedResults";
import { isFinal, isGroups } from "../helpers/GryHelpers";
import SportCode from "components/common/SportCode";
import Status from "components/presentation/Status";
import CaptionTable from "components/general/table/CaptionTable";

const GryResults = ({ data, currentRotation, currentData}) => {
    //console.log(data);
    
    const {breakPoint} = useViewport();
    const { mirs_discipline, mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()
    
    const resultStatus = currentData?.results?.status?.code;  
    const scheduletStatus = currentData?.results?.schedule?.status?.code
    const statusCode = data?.cumulativeResults?.status?.code;
    const statusDesc = data?.cumulativeResults?.status?.description;
    
    const renderRowSubComponent = React.useCallback(({ row }) => {
        let componentExpanded = isGroups(mirs_rsc) ? <TableExpandedGroups row={row?.original} status={resultStatus} /> : <TableExpandedIndividual row={row?.original} status={resultStatus} />;
        return (
          <LoaderSubComponent component={componentExpanded} />
        )
      },
     [resultStatus]
    );

    if (!data?.cumulativeResults?.results) return <NotAvailable />;

    let current = currentData?.results?.items?.filter(item => item?.extendedResultsCurrent)?.find(item => item?.extendedResultsCurrent?.find(erc => erc?.er_code === 'STAGE' && erc?.er_value === 'CURRENT'));

    const isStartList = isStartListStatus(resultStatus);
      
    const isMobile = breakPoint === "sm" || breakPoint === "xs" 

    const getColumns = (rotation, status) => {
        let columns = resultsColumns(rotation, status);
        return columns;    
    }

    const getInitialSortBy = () => {
      let initialSortBy =  data?.cumulativeResults?.results?.some(r => r?.resultRank) ? [{ id: 'Rank', desc: false }] : [{ id: 'StartOrder', desc: false }]
      return initialSortBy;
    }

    const getHiddenColumns = () => {
      let startOrder = isMobile ? ['StartOrder'] : statusCode.includes('OFFICIAL') ? ['StartOrder'] : []
      let apparatus = isMobile ? ['HOOP', 'BALL', 'CLUBS', 'RIBBON', '5_HOOPS', '3_RIBBONS_2_BALLS'] : isGroups(mirs_rsc) ? ['HOOP', 'BALL', 'CLUBS', 'RIBBON'] : ['5_HOOPS', '3_RIBBONS_2_BALLS']; 
      let qualMark = isFinal(mirs_rsc) ? ['QualMark'] : []
      return [...startOrder, ...apparatus, ...qualMark];
    }

    const getCurrentIndicator = (row) => {
        const isCurrent = current?.participant?.code === row?.original?.participant?.code;
        return {className: isCurrent ? 'currentIndicator' : ''}
    }

    let leftCol = statusCode && statusCode.includes('OFFICIAL') ? <><Label data='HeaderResults' /></> : currentRotation ? <><Label data='HeaderRotation' /> {`${currentRotation} / 4`}</> : <></>;
    let rightCol = statusCode && statusCode.includes('OFFICIAL') ? <>{statusDesc}</> : <Status typeToPrint="result" scheduleStatus={scheduletStatus} resultStatus={resultStatus} />;
    const caption = <CaptionTable leftCol={leftCol} rightCol={rightCol} />;

    return (
        <MirsTable
        id={`mirs-table-result-${mirs_rsc}`}
        caption={caption}
        sortable={!isMobile}
        data={data?.cumulativeResults?.results}
        columns={getColumns(currentRotation, statusCode)}
        keyRow={"participant-code"}
        initialSortBy={getInitialSortBy()}
        hiddenColumns={getHiddenColumns()}
        renderRowSubComponent={renderRowSubComponent}
        getRowProps={row => { return getCurrentIndicator(row) }}
    />)
}

export default GryResults;
